import React from 'react'
import { Button } from 'antd'
import CloseOutlined from '@ant-design/icons/CloseOutlined'
import FilterOutlined from '@ant-design/icons/FilterOutlined'

import type { VcnDashboardMetric } from './types'
import { Banner, BannerText } from './VcnManagementMigrationCards.styles'

export const BENEFIT_METRIC_LABELS: Record<VcnDashboardMetric, string> = {
  marqeta_benefits: 'MARQETA · benefit IDs',
  marqeta_active: 'MARQETA · active cards',
  wex_benefits: 'WEX · benefit IDs',
  wex_active: 'WEX · active cards',
  overlap: 'Overlap · both active cards',
  cleanup: 'Clean up · employees with an orphan card',
}

export interface VcnManagementMetricBannerProps {
  /**
   * What the active metric is called, already resolved by the caller. A string
   * rather than a metric enum because both tabs use this banner and their metric
   * vocabularies are different — Benefit Mode's counts benefits, Card Mode's
   * counts cards.
   */
  label: string
  onClear: () => void
}

export function VcnManagementMetricBanner({
  label,
  onClear,
}: VcnManagementMetricBannerProps) {
  return (
    <Banner>
      <BannerText>
        <FilterOutlined />
        Filtered by dashboard metric — <strong>{label}</strong>
      </BannerText>
      <Button icon={<CloseOutlined />} onClick={onClear}>
        Clear filter
      </Button>
    </Banner>
  )
}
